module.exports = __webpack_public_path__ + "static/media/Simple-Line-Icons.dacd16c9.eot";